export enum Locale {
  EN = 'en',
  DE = 'de',
  AU = 'au',
  US = 'us',
}

export enum OutputChannels {
  DE = 'de_DE',
  AU = 'en_AU',
  US = 'en_US',
}

export enum OutputChannelsByModelType {
  usa = 'en_US',
  australia = 'en_AU',
  europe = 'de_DE',
}

export enum ChannelsFullNames {
  Europe = 'europe',
  Usa = 'usa',
  Australia = 'australia',
}
